import "../../styles/loader.css"

export default function Loader(){
    return(<div id="spinner"></div>)
}